// extracted by mini-css-extract-plugin
module.exports = {"insightIconsWrapper":"LEnwhcRh","disabled":"zlU9w6Vu","styledImg":"uKiVCbuI"};